import type { FAQPage } from '@bruce/components'
import type { Faqs } from '@bruce/api/common/faq'

export function formatFaqToStructuredData(faqs: Faqs) {
  return faqs
    .filter((faq) => faq.question && faq.answer)
    .map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })) as FAQPage['mainEntity']
}
